import { useMemo } from 'react';

import { useGetAgentsByAdminQuery } from '@/apis/extended/admin/agentApi';
import { useGetUsersByAdminQuery } from '@/apis/extended/admin/userApi';

/**
 * Agent display names keyed by every id a contract's `agentIdentity` can
 * hold: the Agent directory `_id` (older assignments) or the agent's User
 * `_id` (assignments since the directory → account fix). Users are named by
 * their directory entry when the emails match.
 */
export function useAgentNameById(): Record<string, string> {
  const { data: agentsData } = useGetAgentsByAdminQuery({
    offset: 0,
    limit: 1000,
  });
  const { data: usersData } = useGetUsersByAdminQuery({
    offset: 0,
    limit: 1000,
  });

  return useMemo(() => {
    const m: Record<string, string> = {};
    const nameByEmail: Record<string, string> = {};
    (agentsData?.agents || []).forEach((a: any) => {
      const name = a.name || a.email;
      m[String(a._id)] = name;
      if (a.email) nameByEmail[String(a.email).toLowerCase()] = name;
    });
    (usersData?.users || []).forEach((u: any) => {
      const email = String(u.email || '').toLowerCase();
      const name = nameByEmail[email];
      if (name) m[String(u._id)] = name;
      else if (u.role === 'seller-agent') m[String(u._id)] = u.name || u.email;
    });
    return m;
  }, [agentsData, usersData]);
}
